import api from '../../../shared/api/client';

export const workingCalendarApi = {
  /** Month summaries across DCs */
  list: (params = {}) => api.get('/working-calendar', { params }),
  /** Full month view + holidays + pace for one DC */
  getMonth: (params) => api.get('/working-calendar/month', { params }),
  /** Replace holidays for DC+month */
  saveMonth: (body) => api.put('/working-calendar/month', body),
  /** Pace resolve (auto today when as_of_day omitted and period is current) */
  resolve: (params) => api.get('/working-calendar/resolve', { params }),
};
